import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Investor } from '../../shared/models/investor';

@Component({
  selector: 'app-asset-details',
  templateUrl: './asset-details.component.html',
  styleUrls: ['./asset-details.component.css'],
})
export class AssetDetailsComponent implements OnInit {
  state: 'assets' | 'liabilities' = 'assets';

  constructor() {}

  @Input()
  investor: Investor;
  @Input() flags: any;

  ngOnInit() {
    // Object.keys(this.investor.liabilities)
    console.log(JSON.parse(JSON.stringify(this.investor.liabilities)));
    // Object.assign(
    //   this.investor.liabilities,
    //   availableLiabilityTypes,
    //   this.investor.liabilities,
    // );
    const currentLiabilities  = JSON.parse(JSON.stringify(this.investor.liabilities));
    Object.assign(this.investor.liabilities, availableLiabilityTypes);
    Object.assign(this.investor.liabilities, currentLiabilities);
    console.log(JSON.parse(JSON.stringify(this.investor.liabilities)));
  }

  update(event) {
    this.calculateTotalLiability();
  }

  calculateTotalLiability() {
    this.investor.total_liabilities_value =
      this.investor.liabilities
        .map((l) => l.value || '0')
        .map((l) => parseInt(l))
        .reduce((val1, val2) => val1 + val2, 0) || 0;
  }

  getTotalAssetValue() {
    return (
      this.investor.total_other_assets_value +
        this.investor.total_liquid_financial_assets_value || 0
    );
  }

  getTotalNetworth() {
    this.investor.total_networth =
      this.getTotalAssetValue() - this.investor.total_liabilities_value;
    return this.investor.total_networth;
  }
  moveNext() {
    if (this.state != 'liabilities') {
      this.activateTab('liabilities');
      return false;
    }
    return true;
  }
  moveBack() {
    if (this.state != 'assets') {
      this.activateTab('assets');
      return false;
    }
    return true;
  }

  activateTab(tab) {
    this.state = tab;
  }
}

const availableLiabilityTypes = [
  {
    name: 'home_loan',
    label: 'Home Loan Principal O/s amount',
    value: null,
    min: 10000,
    max: 10000000,
    step: 5000,
  },
  {
    name: 'car_loan',
    label: 'Car Loan Principal O/s amount',
    value: null,
    min: 10000,
    max: 10000000,
    step: 5000,
  },
  {
    name: 'income_tax',
    label: 'Income tax payable',
    value: null,
    min: 5000,
    max: 5000000,
    step: 5000,
  },
  {
    name: 'short_term_loan',
    label: 'Short/Long Term Loan O/s',
    value: null,
    min: 5000,
    max: 5000000,
    step: 5000,
  },
  {
    name: 'credit_card_dues',
    label: 'Credit Card dues (if any)',
    value: null,
    min: 500,
    max: 500000,
    step: 5000,
  },
];



// WEBPACK FOOTER //
// ./src/app/modules/hwcheckup/asset-details/asset-details.component.ts